import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { organizacionApi } from '@/data/api/organizacionApi';
const SUC = 'sucursales-admin';
const PDV = 'pdv-admin';
const MP = 'mp-admin';
// --- Sucursales ---
export function useSucursalesAdmin() {
    return useQuery({
        queryKey: [SUC],
        queryFn: () => organizacionApi.listarSucursales(),
    });
}
export function useCrearSucursal() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => organizacionApi.crearSucursal(v),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [SUC] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'sucursales'] });
        },
    });
}
export function useEditarSucursal() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => organizacionApi.editarSucursal(id, values),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [SUC] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'sucursales'] });
        },
    });
}
export function useDesactivarSucursal() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => organizacionApi.desactivarSucursal(id),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [SUC] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'sucursales'] });
        },
    });
}
// --- PDV ---
export function usePdvs(sucursalId) {
    return useQuery({
        queryKey: [PDV, sucursalId],
        queryFn: () => organizacionApi.listarPdv(sucursalId),
        enabled: Boolean(sucursalId),
    });
}
export function useCrearPdv(sucursalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => organizacionApi.crearPdv(sucursalId, v),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [PDV, sucursalId] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'pdv', sucursalId] });
        },
    });
}
export function useEditarPdv(sucursalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => organizacionApi.editarPdv(sucursalId, id, values),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [PDV, sucursalId] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'pdv', sucursalId] });
        },
    });
}
export function useDesactivarPdv(sucursalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => organizacionApi.desactivarPdv(sucursalId, id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [PDV, sucursalId] }),
    });
}
// --- Meeting points ---
export function useMps(sucursalId) {
    return useQuery({
        queryKey: [MP, sucursalId],
        queryFn: () => organizacionApi.listarMp(sucursalId),
        enabled: Boolean(sucursalId),
    });
}
export function useCrearMp(sucursalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => organizacionApi.crearMp(sucursalId, v),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [MP, sucursalId] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'meeting', sucursalId] });
        },
    });
}
export function useEditarMp(sucursalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => organizacionApi.editarMp(sucursalId, id, values),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [MP, sucursalId] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'meeting', sucursalId] });
        },
    });
}
export function useDesactivarMp(sucursalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => organizacionApi.desactivarMp(sucursalId, id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [MP, sucursalId] }),
    });
}
